<template>
  <div class="top-visual" :class="{ 'is-first': isFirstRun, 'is-repeat': !isFirstRun }">
    <transition name="tv-logo" appear>
      <img
        v-show="logoShown"
        src="@/assets/logo-second.svg"
        alt="RODEO BROS"
        v-if="$store.state.hostName === 'R2' || $store.state.hostName === 'Y2'"
      />
      <img
        v-show="logoShown"
        src="@/assets/logo.svg"
        alt="RODEO BROS"
        v-else
      />
    </transition>
  </div>
</template>

<script>
const SESSION_KEY = 'rb-initial-loader-done'

export default {
  name: 'TopVisual',

  data () {
    return {
      logoShown: false,
      isFirstRun: false
    }
  },

  mounted () {
    this.isFirstRun = !sessionStorage.getItem(SESSION_KEY)

    // 初回は遅め、2回目以降は早めに開始
    const showDelay = this.isFirstRun ? 1600 : 250

    setTimeout(() => {
      this.logoShown = true
    }, showDelay)
  }
}
</script>

<style lang="scss" scoped>
.top-visual {
  position: relative;
  width: 100%;
  height: 60vh;

  /* デフォルト（2回目以降＝早め） */
  --tv-duration: 300ms;
  --tv-offset: 18px;

  &.is-first {
    /* 初回＝ゆっくり */
    --tv-duration: 500ms;
    --tv-offset: 24px;
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    transform: translate(-50%, -50%);
  }
}

/* 上からスライドイン（ブラーなし） */
.tv-logo-enter-active,
.tv-logo-leave-active {
  transition: opacity var(--tv-duration) ease, transform var(--tv-duration) ease;
  will-change: opacity, transform;
}

img.tv-logo-enter,
img.tv-logo-leave-to {
  opacity: 0;
  transform: translate(-50%, calc(-50% - var(--tv-offset)));
}

img.tv-logo-enter-to,
img.tv-logo-leave {
  opacity: 1;
  transform: translate(-50%, -50%);
}

/* モーション軽減 */
@media (prefers-reduced-motion: reduce) {
  .tv-logo-enter-active,
  .tv-logo-leave-active {
    transition: none;
  }
}
</style>
